module.exports = __webpack_public_path__ + "img/liliya.3d6cfb6f.jpg";